import { IpWebComponent } from '../../web-components/ip-web-component';

const statisticValueTemplate = document.createElement('template');
statisticValueTemplate.innerHTML = `
<style>
    :host {
    }
    .statistic {
        display: grid;
        grid-template-columns: 1.5em auto auto;
        grid-template-rows: 1.5em;
        grid-template-areas:
            "icon name value-and-postfix";

        font-size: 1.5em;
        gap: 0.4em;
    }
    .icon-container {
        grid-area: icon;
    }
    .icon {
        width: 100%;
        height: 100%;
    }
    .name {
        grid-area: name;
    }
    .value-and-postfix {
        grid-area: value-and-postfix;
        display: flex;
        justify-content: flex-end;
        gap: 0.2em;
    }
    .value {
        color: var(--theme-primary-color);
        font-weight: bold;
    }
    .postfix {
        color: var(--theme-primary-color);
        font-weight: bold;
    }
    @media(max-width: 1200px) {
        .statistic {
            grid-template-columns: 1.5em auto;
            grid-template-rows: 1.5em auto;
            grid-template-areas:
                "icon name"
                ". value-and-postfix";
            margin-bottom: 1em;
        }
    }
    @media(max-width: 768px) {
        .statistic {
            grid-template-columns: 1.5em auto auto;
            grid-template-rows: 1.5em;
            grid-template-areas:
            "icon name value-and-postfix";
            margin-bottom: 0;
        }
    }
    @media(max-width: 576px) {
        .statistic {
            font-size: 1.2em;
        }
    }
</style>
<div class="statistic">
    <span class="icon-container">
        <img class="icon" />
    </span>
    <span class="name"></span>
    <span class="value-and-postfix">
        <span class="value"></span>
        <span class="postfix"></span>
    </span>
</div>
`;

class StatisticValue extends IpWebComponent {
    constructor() {
        super(statisticValueTemplate);
    }

    // Init component.
    connectedCallback() {
        // Set initial values.
        const iconUrl = this.getProp('icon');
        const iconElm = this.queryUnsafe<HTMLImageElement>('.icon');
        if (iconUrl) {
            iconElm.src = iconUrl;
        } else {
            iconElm.style.display = 'none';
        }
        this.setContentFromProp('.name', 'name');
        this.setContentFromProp('.value', 'value');
        this.setContentFromProp('.postfix', 'postfix');
    }

    static get observedAttributes() {
        return ['value'];
    }

    attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
        if (name === 'value') {
            const valueElm = this.queryUnsafe<HTMLElement>('.value');
            valueElm.textContent = newValue;
        }
    }
}

// Define element, if not already defined.
if (customElements.get('statistic-value') === undefined) {
    customElements.define('statistic-value', StatisticValue);
}
